import styled from "@emotion/styled";
import {Button} from "@mui/material";

export type ButtonProps = {
    disabled?: boolean;
    onClick?: () => void;
    children?: React.ReactNode;
}

export default (props: ButtonProps) =>
    <SButton disabled={props.disabled} onClick={props.onClick}>
        {props.children}
    </SButton>

const SButton = styled(Button)`
  font-size: 14px;
  border: 1px solid #44CAAA;
  border-radius: 6px;
  box-sizing: border-box;
  background: transparent;
  min-width: 127px !important;
  color: #44CAAA;
  text-transform: capitalize;

  .turnoff {
    display: none;
  }
  .turnon {
    display: block;
  }

  &:hover {
    background-color: #DBE4F0;
    color: #1A222D;
    border: 1px solid #DBE4F0;
    .turnoff {
      display: block;
    }
    .turnon {
      display: none;
    }
  }

  &:focus {
    background-color: #DBE4F0;
  }
    
  &:disabled {
    color: #44CAAA;
  }
`;
